import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H5 } from 'foundations-components/transitional/components/H5';
import ContentRoutes from 'ContentUtils/Routes';
// @ts-expect-error Untyped actions
import { closeModal } from 'ContentEditorUI/redux/actions/appActions';
import { getContentTypeLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
// @ts-expect-error Untyped selectors
import { getDashboardUrl } from 'page-editor-ui/redux/selectors/urlSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MlangLimitUpgradeModal = () => {
  const dispatch = useDispatch();
  const onClose = () => dispatch(closeModal());
  const onConfirm = () => {
    window.location.href = ContentRoutes.cmsHubPricingPage();
  };
  const contentTypeLimit = useSelector(getContentTypeLimit);
  const controlCenterUrl = useSelector(getDashboardUrl);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "mlang-limit-alert-modal",
    size: "auto",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "limitExceededError.mlangLimitModal.title",
          options: {
            count: contentTypeLimit.mlangPagesQuantityUsed,
            mlangLimit: contentTypeLimit.mlangPagesLimit
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "limitExceededError.mlangLimitModal.upgrade"
        })
      }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "limitExceededError.mlangLimitModal.message",
        options: {
          controlCenterUrl
        }
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "mlang-limit-alert-modal-confirm",
        use: "primary",
        onClick: onConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "limitExceededError.mlangLimitModal.button"
        })
      })
    })]
  });
};
export default MlangLimitUpgradeModal;